import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Typography } from "antd";
import { 
	getJobRoleRequestDetails
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import Card from "components/card";
import { getLabel } from "utils";



const JobRoleRequestDetails = ({ recordData, getRecord, ...props }) => {
    const {  Paragraph, Text } = Typography;
    const { recordId } = props;

	useEffect(() => {
		if (recordId) {
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	return (
        <Card className="p-10 shadow-sm border border-gray-200 bg-white">
            <Paragraph className="text-sm label-title mb-2">
                <Text strong>Request Status:</Text>{" "} 
                {getLabel(recordData?.jobRequestStatusList, recordData?.jrr_status_id)}
            </Paragraph>
            <Paragraph className="text-sm label-title !mb-0">
                <Text strong>Job Title:</Text>{" "}
                {recordData?.job_role?.jro_job_title}
            </Paragraph>
            <Paragraph className="text-sm label-title !mb-0">
                <Text strong>Count:</Text>{" "}
                {recordData?.job_role?.jro_count}
            </Paragraph>
            <Paragraph className="text-sm label-title">
                <Text strong>Location:</Text>{" "}
                {recordData?.job_role?.jro_location}
            </Paragraph>
            
            <Paragraph className="text-sm label-title">
                 <Text strong>Job Description:</Text>{" "}
                {recordData?.job_role?.jro_job_description}
            </Paragraph>

            {Array.isArray(recordData?.job_role?.jro_key_responsibilities) &&
                recordData.job_role.jro_key_responsibilities.length > 0 && (
                    <>
                        <Text strong>Key Responsibilities:</Text>{" "}
                        <ul className="list-disc pl-8 space-y-2 text-sm label-title mt-2 mb-4">
                            {recordData.job_role.jro_key_responsibilities.map((item, index) => (
                            <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </>
                )}

            {Array.isArray(recordData?.job_role?.jro_preferred_qualifications) &&
                recordData.job_role.jro_preferred_qualifications.length > 0 && (
                    <>
                        <Text strong>Preffered Qualifications:</Text>{" "}
                        <ul className="list-disc pl-8 space-y-2 text-sm label-title mt-2 mb-4">
                            {recordData.job_role.jro_preferred_qualifications.map((item, index) => (
                            <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </>
                )}
            
            <Paragraph className="text-sm label-title ">
                {recordData?.job_role?.jro_add_info}
            </Paragraph>

            {recordData?.job_role?.jro_how_to_apply && (
                <>
                    <Text strong>How to Apply:</Text>{" "}
                    <Paragraph className="text-sm label-title mt-2">
                        {recordData.job_role.jro_how_to_apply}
                    </Paragraph>
                </>
            )}
        </Card>
	);
};

const mapStateToProps = (state) => ({
	recordData: state.jobRoleRequest.jobRoleRequestDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobRoleRequestDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleRequestDetails);